import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';

import moment from 'moment';

const Label = (props) => {
  return(
    <tr>
      <td>
        <NavLink to={`/inventory/${props.product.id}/`}>
          {props.product.id}
        </NavLink>
      </td>
      <td className="hidden-xs-down">
        <NavLink to={`/session/${props.session}/`}>
          {props.session}
        </NavLink>
      </td>
      <td className="hidden-sm-down">{props.product.vendor? props.product.vendor : 'No vendor'}</td>
      <td className="hidden-sm-down">{props.product.brand? props.product.brand.brand_name :''}</td>
      <td className="hidden-md-down">{props.product.packing_date?  moment(props.product.packing_date).format('L') : '' }</td>
      <td className="hidden-md-down">{props.product.expiration_date?  moment(props.product.expiration_date).format('L') : '' }</td>
      <td>{props.product.item.name}</td>
      <td className="hidden-sm-down">{props.product.weight}</td>
      <td className="hidden-sm-down">{props.product.number_items}</td>
      <td>
        <span className="btn btn-info mr-0" onClick={()=>props.printLabel(props.index, props.alreadyPrinted)}>
          <i className="fa fa-print"></i>
        </span>
      </td>
    </tr>
  )
}

export default class LabelProductionList extends Component {
  render() {
    return (
      <tbody>
        {this.props.output.map((product,index)=>{
          return (
            <Label product={product}
              session={this.props.session}
              index={index}
              printLabel={this.props.printLabel}
              key={index}
              alreadyPrinted={this.props.alreadyPrinted}/>
          )
        })}
      </tbody>
    )
  }
}
